import { render, staticRenderFns } from "./SecondhandList.vue?vue&type=template&id=66ba1458&scoped=true&lang=pug"
import script from "./SecondhandList.vue?vue&type=script&lang=ts"
export * from "./SecondhandList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba1458",
  null
  
)

export default component.exports